import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from './context/AuthContext';

interface RoleProtectedRouteProps {
    allowedRoles: string[];
    allowedClient: boolean
    allowedInternal: boolean
}

/**
 * Questo componente agisce come un "guardiano".
 * Controlla se il ruolo dell'utente attuale è incluso nella lista dei ruoli permessi.
 * Se l'utente è autorizzato, mostra la pagina richiesta (tramite <Outlet />).
 * Altrimenti, lo reindirizza a una pagina di "Accesso Negato".
 */
const RoleProtectedRoute: FC<RoleProtectedRouteProps> = ({ allowedRoles, allowedClient, allowedInternal }) => {
    const { user } = useAuth();

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    const isAuthorized = allowedRoles.includes(user.role) && ((allowedClient && user.client) || (allowedInternal && allowedInternal));

    return isAuthorized ? <Outlet /> : <Navigate to="/unauthorized" replace />;
};

export default RoleProtectedRoute;
